module.exports = __webpack_public_path__ + "static/media/logo.67175c8f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/logo.svg
// module id = 726
// module chunks = 1